import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const BellIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          fill="currentColor"
          d="M14.432 8.8c.29 0 .518-.229.518-.519V.846a.516.516 0 0 0-.518-.528.516.516 0 0 0-.519.528V8.28c0 .3.22.519.519.519m2.091-1.002c.29 0 .519-.229.519-.519V1.83a.51.51 0 0 0-.519-.51.51.51 0 0 0-.51.51v5.45c0 .29.23.518.51.518M8.991 19.865c1.995 0 3.366-1.53 3.446-3.217h3.612c.914 0 1.468-.5 1.468-1.239 0-.932-.853-1.731-1.653-2.505-.51-.51-.72-1.485-.773-2.329-.009-.158-.018-.316-.018-.466-.597.185-1.213.115-1.722-.307.008.263.017.545.017.835.027 1.511.352 2.47.88 3.076.439.5.93.967 1.15 1.222v.105H2.566v-.105c.229-.255.739-.721 1.17-1.222.606-.694.887-1.951.975-3.621.105-3.569 1.195-4.755 2.62-5.142.21-.053.333-.158.35-.395.036-.668.352-1.134.774-1.292.211-.783.897-1.38 1.775-1.38.053 0 .106 0 .168.009 0-.027 0-.044.008-.07a2.9 2.9 0 0 0-1.415-.379c-1.31 0-2.285.888-2.619 2.048-2.294.835-3.26 3.059-3.375 6.39-.114 1.204-.255 2.417-.879 3.023-.79.774-1.652 1.573-1.652 2.505 0 .739.562 1.24 1.468 1.24h3.612c.079 1.678 1.45 3.216 3.445 3.216M12.34 7.332c.29 0 .518-.228.518-.527v-4.51a.52.52 0 0 0-1.037 0v4.51c0 .299.229.527.519.527m6.284-1.107c.299 0 .519-.22.519-.519V3.395a.52.52 0 0 0-1.037 0v2.311c0 .299.228.519.518.519m-8.393-.457a.514.514 0 0 0 .527-.51V3.86a.516.516 0 0 0-.527-.518.51.51 0 0 0-.51.518v1.398c0 .281.228.51.51.51M8.99 18.459c-.993 0-1.714-.712-1.784-1.81h3.568c-.061 1.098-.782 1.81-1.784 1.81"
        ></path>
      </svg>
    </div>
  );
};

export default BellIcon;
